// extracted by mini-css-extract-plugin
export var cardIcon = "_q-5";
export var cardIconUnframed = "_q-9";
export var checkboxCard = "_q-0";
export var checkboxCardSelected = "_q-4";
export var disabled = "_q-2";
export var interactive = "_q-1";
export var outerBorder = "_q-3";
export var spacerMedium = "_q-8";
export var spacerSmall = "_q-7";
export var spacerXsmall = "_q-6";